import React, { useEffect } from 'react';
import Auth from "../../utils/auth";
import { UrlSearch } from '../../utils/utils';

function UsmsLogin(props) {

    useEffect(() => {
        if (Auth.getLocalAuthName()) {
            window.location.href = `${decodeURI(UrlSearch("ureferer"))}?user=${Auth.getLocalAuthName()}&state=${Date.now()}`
        } else {
            window.location.href = `/login?referer=${encodeURI(window.location.toString())}`;
        }
    }, [])

    return <div />
}

export default UsmsLogin